import { createSlice } from '@reduxjs/toolkit';

const appListFilterSlice = createSlice({
    name: 'appListfilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        getPlateform: [],
    },
    reducers: {
        fetchPlatformOption: (state, action) => {
            state.getPlateform = action.payload
            state.isLoading = false
        },
        fetchPlatformOptionError: (state, action) => {
            state.isLoading = false
            state.isError = true
            state.error = action?.payload?.response?.data?.message
        }
    },
});

export const { fetchPlatformOption, fetchPlatformOptionError } = appListFilterSlice.actions;
export default appListFilterSlice.reducer;